module.exports = __webpack_public_path__ + "files/2ef2003c1861f9a5252e811072d00503.svg";